<div class="meo-input-bar"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  [class.drag-over]="isDragOver()">

  <!-- Attachment preview strip -->
  @if (pendingAttachment(); as att) {
    <div class="attachment-preview">
      @if (isImage(att) && att.thumbnailDataUrl) {
        <img [src]="att.thumbnailDataUrl" class="attachment-thumb" alt="preview" />
      } @else {
        <div class="attachment-icon-box">
          <app-svg name="attachment" height="16" width="16" [color]="ss.theme().color7"></app-svg>
        </div>
      }
      <div class="attachment-info">
        <span class="attachment-name">{{ att.fileName }}</span>
        <span class="attachment-size">{{ getFileSize(att.originalSize) }}</span>
      </div>
      <button class="attachment-remove" (click)="removeAttachment()">
        <app-svg name="close" height="14" width="14" [color]="ss.theme().color7"></app-svg>
      </button>
    </div>
  }

  <!-- Attachment error -->
  @if (attachmentError(); as errKey) {
    <div class="attachment-error">
      <span>{{ ss.t(errKey) || errKey }}</span>
    </div>
  }

  <!-- Processing indicator -->
  @if (isProcessingFile()) {
    <div class="attachment-processing">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
  }

  <div class="input-container">
    <button class="attach-btn" (click)="onAttachClick()" [disabled]="isLoading() || isProcessingFile()">
      <app-svg name="attachmentSm" height="18" width="18" [color]="ss.theme().color7"></app-svg>
    </button>

    <textarea
      #textInput
      class="text-input"
      [(ngModel)]="inputText"
      (keydown)="onKeyDown($event)"
      (input)="onInput()"
      [placeholder]="ss.t('meo_input_placeholder')"
      [disabled]="isLoading()"
      rows="1"
    ></textarea>

    @if (canSend) {
      <button class="send-btn" (click)="onSend()" [disabled]="isLoading()">
        <app-svg name="send" height="20" width="20" [color]="ss.theme().color12"></app-svg>
      </button>
    } @else if (isVoiceSupported() && !isLoading()) {
      <button class="mic-btn" (click)="onMicPress()" [class.recording]="isRecording()">
        <app-svg name="mic" height="20" width="20"
          [color]="isRecording() ? ss.theme().color11 : ss.theme().color12"></app-svg>
      </button>
    }
  </div>

  <!-- Hidden file input -->
  <input #fileInput type="file" [accept]="acceptedTypes" (change)="onFileSelected($event)" class="hidden-input" />
</div>
